<template>
  <div class="search-results">
    <div class="container">
      <h2>搜索"{{ searchQuery }}"的结果</h2>

      <div v-if="loading" class="loading">加载中...</div>
      <div v-else-if="error" class="error">搜索失败，请稍后再试</div>
      <div v-else>
          没有找到？
          <router-link to="/professor/create">
            去创建导师
          </router-link>

        <div class="professor-list">
          <div
              v-for="professor in professors"
              :key="professor.id"
              class="professor-card"
          >
            <h3>{{ professor.name }}</h3>
            <p>{{ professor.school_name }} · {{ professor.college_name }}</p>

            <!-- 检查 professor.id 是否存在 -->
            <router-link
                :to="{
                name: 'ProfessorDetail',
                params: { id: professor.id },
                query: {
                  name: professor.name,
                  school_name: professor.school_name,
                  college_name: professor.college_name
                }
              }"
                class="view-detail"
            >
              查看详情
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BlogFooter from '@/components/BlogFooter.vue'
import axios from 'axios'
import {API_BASE_URL} from "@/config";

export default {
  name: 'ProfessorSearchResults',
  components: { BlogFooter },
  data() {
    return {
      searchQuery: '',
      professors: [],
      loading: true,
      error: false
    }
  },
  watch: {
    '$route.query.q': {
      immediate: true,
      handler(newVal) {
        this.searchQuery = newVal || ''
        this.fetchSearchResults()
      }
    }
  },
  created() {
    this.searchQuery = this.$route.query.q || ''
    this.fetchSearchResults()
  },
  methods: {
    async fetchSearchResults() {
      this.loading = true
      this.error = false
      try {
        const response = await axios.get(`${API_BASE_URL}/professors/search`, {
          params: {
            name: this.searchQuery
          }
        })
        if (response.data.code === 200) {
          // 提取实际的教授数据
          this.professors = response.data.data;
        } else {
          console.error('搜索失败，返回码非 200:', response.data);
        }
      } catch (error) {
        console.error('搜索失败:', error)
        this.error = true
      } finally {
        this.loading = false
      }
    },


  }
}
</script>

<style scoped>
.search-results {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.container {
  flex: 1;
  padding: 2rem;
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
}

.loading, .no-results {
  text-align: center;
  padding: 2rem;
  font-size: 1.2rem;
}

.create-btn {
  display: block;
  margin: 1.5rem auto 0;
  padding: 1rem 2rem;
  background-color: #3498db;
  color: white;
  border-radius: 8px;
  text-decoration: none;
  font-size: 1.2rem;
  font-weight: bold;
  width: fit-content;
  transition: all 0.3s ease;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.create-btn:hover {
  background-color: #2980b9;
  transform: translateY(-2px);
  box-shadow: 0 6px 8px rgba(0, 0, 0, 0.15);
}

.professor-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 1.5rem;
  margin-top: 2rem;
}

.professor-card {
  background: white;
  border-radius: 8px;
  padding: 1.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

.error {
  text-align: center;
  padding: 2rem;
  font-size: 1.2rem;
  color: #e74c3c;
}
}

.rating {
  margin: 0.5rem 0;
  color: #f39c12;
}

.stars {
  letter-spacing: 2px;
}

.view-detail {
  display: inline-block;
  margin-top: 1rem;
  color: #3498db;
  text-decoration: none;
}

.view-detail:hover {
  text-decoration: underline;
}
</style>